import { AllocationHeaderRowType } from "../../../repertoire/types/usageTypes/IAllocationRowTypes";

export function getAllocationRows(result: any): any[] {
    if (Array.isArray(result)) {
        return result;
    }

    return result?.rows ?? result?.Rows ?? [];
}

function parseUsageDetails(usageDetail: unknown): any[] {
    if (!usageDetail) {
        return [];
    }

    if (Array.isArray(usageDetail)) {
        return usageDetail;
    }

    if (typeof usageDetail === 'string') {
        try {
            const parsed = JSON.parse(usageDetail);
            return Array.isArray(parsed) ? parsed : [];
        } catch {
            return [];
        }
    }

    return [];
}

export function mapAllocationRow(allocation: any, index: number): AllocationHeaderRowType {
    const usageGroupTitle = allocation.UsageGroupTitle ?? allocation.usageGroupTitle ?? '';

    return {
        key: index,
        AllocationUsageHeaderId: allocation.AllocationUsageHeaderID ?? '',
        PoolCode: allocation.PoolCode ?? '',
        WorkNumber: allocation.WorkNumber ?? '',
        WorkName: allocation.WorkName ?? '',
        UsageGroupTitle: usageGroupTitle,
        ProductNumber: allocation.ProductNumber ?? '',
        AllocationDate: allocation.AllocationDate ?? '',
        AllocationWeight: allocation.AllocationWeight ? Number(allocation.AllocationWeight).toString() : '',
        TotalAmount: allocation.TotalAmount ? Number(allocation.TotalAmount).toString() : '',
        UsageDetails: parseUsageDetails(allocation.usage_detail).map(x => ({
            ...x,
            PoolCode: allocation.PoolCode,
            WorkNumber: allocation.WorkNumber ?? '',
            WorkName: allocation.WorkName ?? '',
            UsageGroupTitle: usageGroupTitle
        })),
        IsSelected: false,
        UsageGroupID: allocation.UsageGroupID ?? ''
    };
}